import * as Sentry from '@sentry/react';
import { useToast } from '@context/toast';
import { AudioRewardDownloadableUrlDocument, fetchGQL } from '@graphql/reactQuery';

export const useDownloadAudio = (trackId: string) => {
  const { openToast } = useToast();

  const onDownload = async () => {
    try {
      const { data } = await fetchGQL(AudioRewardDownloadableUrlDocument, {
        variables: {
          trackId,
        },
      });

      if (!data.downloadableTrackURLForAudioReward) {
        throw new Error('No downloadable URL found');
      }

      window.open(data.downloadableTrackURLForAudioReward, '_blank', 'noopener');
    } catch (e) {
      openToast({
        text: "Sorry, we couldn't download the audio file. Please try again.",
        variant: 'error',
      });
      Sentry.captureException(e, {
        tags: {
          trackId,
        },
      });
    }
  };

  return onDownload;
};
